import { Directive, ElementRef, EventEmitter, HostBinding, Injector, Input, Output, SimpleChanges } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { Observable } from 'rxjs';
import { ISelectedPosition } from '../../../site/conditionMonitoring/condition-monitoring.service';

@Directive({
    selector: 'oc-vehicle-schematic'
})
export class OcVehicleSchematicDirective extends UpgradeComponent {
    @Input() public vehicleObject!: Observable<any>;
    @Input() maxWidth!: number;
    @Input() maxHeight!: number;
    @Input() includeFitments!: boolean;
    @Input() specification!: any;
    @Input() schematicDate!: any;
    @Input() openModule!: any;
    @Input() scaleToFit!: boolean;
    @Input() topAxle!: number;
    @Input() leftPos!: number;
    @Input() notification!: any;
    @Input() schematicWidth!: number;
    @Input() schematicHeight!: number;
    @Input() overflowX!: number;
    @Input() overflowY!: number;
    @Input() svgScale!: number;
    @Input() schematicHasScrollbar!: boolean;
    @Input() showChains!: boolean;
    @Input() showRims!: boolean;
    @Input() highlightSelected: boolean;
    @Input() excludeReadings!: boolean;
    @Input() zoomRect!: any;
    @Input() processing!: any;
    @Input() selectedComponent: any;
    @Output() tyreSelected: EventEmitter<{component: ISelectedPosition, position: string}>;
    @Input() selectedPosition!: any;
    @Input() showPositionLabels: string;
    @Input() showPositionAsReading!: any;
    @Input() redraw!: any;
    @Input() roundAxles!: any;
    @Input() doRefresh!: any;
    @Input() positionsWide!: number;
    @Input() positionsHigh!: number;
    @Input() changeCount!: any;
    @Input() allowDragDrop!: any;
    @Input() showChangeCount!: any;
    @Input() positionView!: string;
    @Input() fitComponent!: any;
    @Input() removeComponents!: any;
    @Input() chevronIsVisible!: any;
    @Input() canOpenComponentDetails!: boolean;
    @Input() useReadingSequence!: boolean;
    @Input() disabledSegments!: boolean;
    @Input() onLabelSelected!: any;
    @Input() buildCSS!: any;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('ocVehicleSchematic', elementRef, injector);
    }
}